import { announcementTypes } from './announcementTypes'

const initialState = {
    Announcement: {},
    allAdminAnnouncement: [],
    allAnnouncement: [],
    meta: {},
    loading: false,
    crudLoading: false,
}

const announcement = (state = initialState, action) => {
    switch (action.type) {
        //Add New Announcement By Admin
        case announcementTypes.ADD_NEW_ANNOUNCEMENT_BY_ADMIN_START:
            return {
                ...state,
                loading: true,
            }
        case announcementTypes.ADD_NEW_ANNOUNCEMENT_BY_ADMIN_SUCCESS:
            return {
                ...state,
                allAdminAnnouncement: action.payload,
            }
        case announcementTypes.ADD_NEW_ANNOUNCEMENT_BY_ADMIN_FAILED:
            return {
                ...state,
                allAdminAnnouncement: action.payload,
                loading: false,
            }
        case announcementTypes.ADD_NEW_ANNOUNCEMENT_BY_ADMIN_END:
            return {
                ...state,
                loading: false,
            }

        //get All Announcement By Admin
        case announcementTypes.GET_ALL_ANNOUNCEMENT_BY_ADMIN_START:
            return {
                ...state,
                loading: true,
            }
        case announcementTypes.GET_ALL_ANNOUNCEMENT_BY_ADMIN_SUCCESS:
            return {
                ...state,
                allAdminAnnouncement: action.payload,
                meta: action.meta,
            }
        case announcementTypes.GET_ALL_ANNOUNCEMENT_BY_ADMIN_FAILED:
            return {
                ...state,
                loading: false,
            }
        case announcementTypes.GET_ALL_ANNOUNCEMENT_BY_ADMIN_END:
            return {
                ...state,
                loading: false,
            }

        //get An Announcement
        case announcementTypes.GET_AN_ANNOUNCEMENT_START:
            return {
                ...state,
                loading: true,
            }
        case announcementTypes.GET_AN_ANNOUNCEMENT_SUCCESS:
            return {
                ...state,
                Announcement: action.payload,
            }
        case announcementTypes.GET_AN_ANNOUNCEMENT_FAILED:
            return {
                ...state,
                loading: false,
            }
        case announcementTypes.GET_AN_ANNOUNCEMENT_END:
            return {
                ...state,
                loading: false,
            }

        //update Announcement By Admin
        case announcementTypes.UPDATE_ANNOUNCEMENT_BY_ADMIN_START:
            return {
                ...state,
                loading: true,
            }
        case announcementTypes.UPDATE_ANNOUNCEMENT_BY_ADMIN_SUCCESS:
            return {
                ...state,
                allAdminAnnouncement: action.payload,
            }
        case announcementTypes.UPDATE_ANNOUNCEMENT_BY_ADMIN_FAILED:
            return {
                ...state,
                loading: false,
                allAdminAnnouncement: action.payload,
            }
        case announcementTypes.UPDATE_ANNOUNCEMENT_BY_ADMIN_END:
            return {
                ...state,
                loading: false,
            }

        //delete Announcement By Admin
        case announcementTypes.DELETE_ANNOUNCEMENT_BY_ADMIN_START:
            return {
                ...state,
                loading: true,
            }
        case announcementTypes.DELETE_ANNOUNCEMENT_BY_ADMIN_SUCCESS:
            return {
                ...state,
                allAdminAnnouncement: action.payload,
            }
        case announcementTypes.DELETE_ANNOUNCEMENT_BY_ADMIN_FAILED:
            return {
                ...state,
                loading: false,
                allAdminAnnouncement: action.payload,
            }
        case announcementTypes.DELETE_ANNOUNCEMENT_BY_ADMIN_END:
            return {
                ...state,
                loading: false,
            }

        //get All Announcement
        case announcementTypes.GET_ALL_ANNOUNCEMENT_START:
            return {
                ...state,
                loading: true,
            }
        case announcementTypes.GET_ALL_ANNOUNCEMENT_SUCCESS:
            return {
                ...state,
                allAnnouncement: action.payload,
                meta: action.meta,
            }
        case announcementTypes.GET_ALL_ANNOUNCEMENT_FAILED:
            return {
                ...state,
                loading: false,
            }
        case announcementTypes.GET_ALL_ANNOUNCEMENT_END:
            return {
                ...state,
                loading: false,
            }

        default:
            return state
    }
}

export default announcement
